import React from "react";
import {Modal} from "react-bootstrap";
import "./AddressForm.scss";
import Strings from "../../config/Strings";
import {formatCityLine, formatStreetLine, fromValidationSuggestion} from "./AddressValidation";

const FIELD_NAMES = {
    STREET: Strings.PURCHASE_CONTACT_STREET,
    HOUSE_NUMBER: Strings.PURCHASE_ADDRESS_HOUSE_NO_LONG,
    POSTAL_CODE: Strings.PURCHASE_CONTACT_POSTAL_CODE,
    CITY: Strings.PURCHASE_CONTACT_CITY,
    COUNTRY: Strings.PURCHASE_CONTACT_COUNTRY,
};

/**
 * Asks the customer to check an address the address validation could not confirm as entered: either to take over
 * the suggested address (status SUGGESTION) or to check the address (status UNCONFIRMED). The customer can always
 * keep the entered address.
 */
export default function AddressValidationModal({validation, enteredAddress, onAcceptSuggestion, onKeepInput, onCorrectInput, onExited}) {
    const suggestion = validation?.status === "SUGGESTION" ? fromValidationSuggestion(validation.suggestedAddress) : null;
    const unconfirmedFieldNames = (validation?.unconfirmedFields || [])
        .map(field => FIELD_NAMES[field])
        .filter(name => name != null);

    const renderAddress = (title, address, highlighted) => (
        <div className={"address-validation-address" + (highlighted ? " highlighted" : "")}>
            <div className="address-validation-address-title">{title}</div>
            <div>{formatStreetLine(address)}</div>
            <div>{formatCityLine(address)}</div>
        </div>
    );

    return (
        <Modal show={validation != null}
               onHide={onCorrectInput}
               onExited={onExited}
               restoreFocus={false}
               centered
               dialogClassName="address-validation-modal"
               aria-labelledby="address-validation-title">
            <Modal.Body>
                <h2 id="address-validation-title" className="address-validation-title">{Strings.PURCHASE_ADDRESS_CHECK_TITLE}</h2>
                {suggestion ?
                    <>
                        <p>{Strings.PURCHASE_ADDRESS_SUGGESTION_TEXT}</p>
                        <div className="address-validation-addresses">
                            {renderAddress(Strings.PURCHASE_ADDRESS_YOUR_INPUT, enteredAddress, false)}
                            {renderAddress(Strings.PURCHASE_ADDRESS_SUGGESTION, suggestion, true)}
                        </div>
                    </>
                    :
                    <>
                        <p>{Strings.PURCHASE_ADDRESS_UNCONFIRMED_TEXT}</p>
                        <div className="address-validation-addresses">
                            {renderAddress(Strings.PURCHASE_ADDRESS_YOUR_INPUT, enteredAddress, false)}
                        </div>
                        {unconfirmedFieldNames.length > 0 &&
                            <p className="address-validation-unconfirmed">
                                {Strings.PURCHASE_ADDRESS_UNCONFIRMED_FIELDS.replace("{0}", unconfirmedFieldNames.join(", "))}
                            </p>
                        }
                    </>
                }
                <div className="address-validation-buttons">
                    {suggestion ?
                        <>
                            <button type="button" className="address-validation-button" onClick={onKeepInput}>
                                {Strings.PURCHASE_ADDRESS_KEEP_INPUT}
                            </button>
                            <button type="button" className="address-validation-button primary" onClick={onAcceptSuggestion}>
                                {Strings.PURCHASE_ADDRESS_SUGGESTION_ACCEPT}
                            </button>
                        </>
                        :
                        <>
                            <button type="button" className="address-validation-button" onClick={onKeepInput}>
                                {Strings.PURCHASE_ADDRESS_INPUT_IS_CORRECT}
                            </button>
                            <button type="button" className="address-validation-button primary" onClick={onCorrectInput}>
                                {Strings.PURCHASE_ADDRESS_CORRECT_INPUT}
                            </button>
                        </>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
}
